import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "151.568",
  x2: "100",
  y2: "12",
  gradientTransform: "matrix(1 0 0 -1 0 202)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M29.9 173.1c-2.8-.1-5.5-1.4-7.4-3.5-1.9-2.1-2.9-4.9-2.8-7.7V38.1c-.1-2.8.9-5.6 2.8-7.7 1.9-2.1 4.6-3.4 7.4-3.5L102.6 10c2.8.1 5.5 1.4 7.4 3.5 1.9 2.1 2.9 4.9 2.8 7.7v157.5c.1 2.8-.9 5.6-2.8 7.7-1.9 2.1-4.6 3.4-7.4 3.5l-72.7-16.8zM90.4 100c0 12.4 2.5 22.5 5.6 22.5 3.1 0 5.6-10.1 5.6-22.5S99.1 77.5 96 77.5c-3.1 0-5.6 10.1-5.6 22.5zm33.7 84.4V15.6h45c1.5 0 2.9.3 4.3.9 1.4.6 2.6 1.4 3.6 2.4s1.9 2.3 2.4 3.6c.6 1.4.9 2.8.9 4.3V173c0 1.5-.3 2.9-.9 4.3-.6 1.4-1.4 2.6-2.4 3.6s-2.3 1.9-3.6 2.4c-1.4.6-2.8.9-4.3.9h-45z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}